import React from 'react';
import styled from 'styled-components';
import Notification from '../../../classes/Notification/Notification';
import { blue6 } from '../../../colors/COLORS';
import { uiTextMedium } from '../../../typography';

interface Props {
  notification: Notification
}

const MeetingText = styled.span`
  color: ${blue6};
  ${uiTextMedium}
`;

function NotificationSubHeading({ notification }: Props) {
  if (notification.type === 'invite') {
    return (
      <div>
        {notification.content.title}
      </div>
    );
  }
  return (
    <div>
      Mentioned you in
      <MeetingText>
    &nbsp;
        {notification.source.identifier2}
    &nbsp;
      </MeetingText>
      notes
    </div>
  );
}

export default NotificationSubHeading;
